import { Injectable, TemplateRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  SimpleModalComponent,
  SimpleModalData,
} from './modals/simple-modal/simple-modal.component';
import {
  YouTubeVideoModalComponent,
  YouTubeVideoPlayerOptions,
} from './modals/youtube-video-modal/youtube-video-modal.component';
import { ErrorIncorrectStatusModalComponent } from './modals/error-incorrect-status-modal/error-incorrect-status-modal.component';
import {
  StatusDescriptionModalComponent,
  StatusDescriptionModalData,
} from './modals/status-description-modal/status-description-modal.component';
import { UniversalErrorModalComponent } from './modals/universal-error-modal/universal-error-modal.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
  constructor(private _dialog: MatDialog) {}

  public openModalFromComponent<Component, ModalDataType = null>(
    component: ComponentType<Component>,
    data: ModalDataType | null = null,
  ): MatDialogRef<Component> {
    return this._dialog.open<Component, ModalDataType>(component, {
      data: data,
      panelClass: 'app-dialog-container',
      disableClose: true,
      autoFocus: false,
    });
  }

  public openModalFromTemplate<Template, ModalDataType = null>(
    template: TemplateRef<Template>,
    data: ModalDataType | null = null,
  ): MatDialogRef<Template> {
    return this._dialog.open<Template>(template, {
      data: data,
      panelClass: 'app-dialog-container',
      disableClose: true,
      autoFocus: false,
    });
  }

  public openSimpleModal(
    data: SimpleModalData,
  ): MatDialogRef<SimpleModalComponent> {
    return this.openModalFromComponent<SimpleModalComponent, SimpleModalData>(
      SimpleModalComponent,
      data,
    );
  }

  public openYouTubeVideoModal(
    data: YouTubeVideoPlayerOptions,
  ): MatDialogRef<YouTubeVideoModalComponent> {
    return this.openModalFromComponent<
      YouTubeVideoModalComponent,
      YouTubeVideoPlayerOptions
    >(YouTubeVideoModalComponent, data);
  }

  /**
   * Opens suspended error modal
   */
  public openErrorIncorrectStatusModal(): MatDialogRef<ErrorIncorrectStatusModalComponent> {
    return this.openModalFromComponent(ErrorIncorrectStatusModalComponent);
  }

  public openUniversalErrorModal(): MatDialogRef<UniversalErrorModalComponent> {
    return this.openModalFromComponent(UniversalErrorModalComponent);
  }

  public openCompleteStatusDescriptionsModal(): MatDialogRef<StatusDescriptionModalComponent> {
    const config: StatusDescriptionModalData = {
      enabledStatusDescriptions: [
        'dueNow',
        'inReview',
        'updateSoon',
        'upToDate',
        'rejected',
      ],
    };
    return this.openModalFromComponent(StatusDescriptionModalComponent, config);
  }

  public openReviewStatusDescriptionsModal(): MatDialogRef<StatusDescriptionModalComponent> {
    const config: StatusDescriptionModalData = {
      enabledStatusDescriptions: ['inReview'],
    };
    return this.openModalFromComponent(StatusDescriptionModalComponent, config);
  }
}
